export const PRIMARY_COLOR = "#0F766E";
export const SECONDARY_COLOR = "#F16726";

export const PRIMARY_BUTTON_STYLE = {
    backgroundColor: "#0F766E",
    borderColor: "#0F766E",
    color: "#ffffff"
};

export const SECONDARY_BUTTON_STYLE = {
    backgroundColor: SECONDARY_COLOR,
    borderColor: SECONDARY_COLOR,
    color: "#ffffff"
};
